import { ChevronsUpDown } from 'lucide-react'
import { cn } from '@/lib/utils/helpers'
import styles from '@/features/invitee/styles/invitesParity.module.css'
import type { ProductTableSortColumnHeaderProps, ProductTableSortIconProps } from '../types/components'

export function ProductTableSortIcon({ column, orderBy, sortBy }: ProductTableSortIconProps) {
  const isActive = orderBy === column
  return (
    <span
      aria-hidden="true"
      className={cn(styles.sortIcon, isActive && styles.sortIconActive)}
    >
      {isActive ? (sortBy === 'asc' ? '▲' : '▼') : <ChevronsUpDown className="h-3 w-3" />}
    </span>
  )
}

export function ProductTableSortColumnHeader({
  column,
  orderBy,
  sortBy,
  onSort,
  children,
  align = 'center',
  className = '',
  'data-testid': testId,
  'aria-sort': ariaSort,
}: ProductTableSortColumnHeaderProps) {
  return (
    <th
      data-testid={testId ?? `product-table-sort-${column}`}
      scope="col"
      aria-sort={ariaSort}
      className={cn(
        'cursor-pointer select-none',
        align === 'center' ? '!text-center' : '!text-left',
        className,
      )}
      onClick={() => onSort(column)}
    >
      <button
        type="button"
        className={cn(
          styles.sortHeaderButton,
          styles.propertySortHeaderButton,
          'flex-nowrap',
          align === 'center' ? 'justify-center' : 'justify-start',
        )}
        onClick={(event) => {
          event.stopPropagation()
          onSort(column)
        }}
      >
        <span
          className={cn(
            styles.sortHeaderLabel,
            'whitespace-nowrap',
            align === 'start' ? 'text-left' : 'text-center',
          )}
        >
          {children}
        </span>
        <ProductTableSortIcon column={column} orderBy={orderBy} sortBy={sortBy} />
      </button>
    </th>
  )
}
